module.exports = __webpack_public_path__ + "static/media/top.fd31c009.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/top.svg
// module id = 114
// module chunks = 0